module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h3', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-foreword has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/anotefromjeansasson"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A Note From Jean Sasson")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-prologue has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/prologue"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Prologue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/chapterone"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter One")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chaptertwo",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Two")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chapterthree",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Three")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chapterfour",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Four")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chapterfive",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Five")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chaptersix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Six")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chapterseven",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Seven")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chaptereight",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Eight")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chapternine",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Nine")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chapterten",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Ten")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chaptereleven",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Eleven")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/chaptertwelve",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Chapter Twelve")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-epilogue has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Epilogue")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/allaboutjeansasson",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("All About Jean Sasson")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/excerptfromprincesssultanascircle",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Excerpt from Princess Sultana’s Circle")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0